import { OrgUser } from "../types";

/**
 * Options for the "on behalf of" select: the signed-in user first as selfLabel,
 * everyone else as "Name (email)" so members with the same name can be told apart.
 */
export default function memberOptions(members: OrgUser[], selfId: string | undefined, selfLabel: string) {
  const self = members.filter((m) => m.userId === selfId).map((m) => ({ value: `${m.userId}`, text: selfLabel }));
  const others = members
    .filter((m) => m.userId !== selfId)
    .map((m) => ({ value: `${m.userId}`, text: m.email ? `${m.candidate} (${m.email})` : `${m.candidate}` }));
  return [...self, ...others];
}
